import React from "react";
import { Box, TextField } from "convertupleads-theme";
import PreviewAndEditor from "../../../../common/PreviewAndEditor";

const TextFieldSizes = () => {
  return (
    <>
      <Box sx={{ width: "80%", marginInline: " auto", p: 3 }}>
        <PreviewAndEditor
          title={"Default and Small size textField"}
          language={"js"}
          value={
            '          <TextField />\n' +
            '          <TextField size={"small"} />'
          }
        >
          <TextField placeholder={"Default"} />
          <TextField size={"small"} placeholder={"small"} />
        </PreviewAndEditor>
      </Box>
    </>
  );
};

export default TextFieldSizes;
